"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const utils_1 = require("../utils");
const NAME = "RawQueryError";
class RawQueryError extends Error {
    constructor(message, request, ctrl, response, error) {
        const localMessage = message || (error && error.message) || "Unknown fetchRawQuery error";
        super(localMessage);
        this.request = request;
        this.error = error || null;
        this.response = response || null;
        this.name = NAME;
        this.ctrl = ctrl;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, RawQueryError);
        }
    }
}
RawQueryError.isInstanceOf = (obj) => (0, utils_1.isInstanceOfError)(obj, NAME);
exports.default = RawQueryError;
